import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../session.service';

export const isSessionValid: CanActivateFn = () => {
    const router = inject(Router);
    const session = inject(SessionService);

    if (!session.isValid()) {
        session.logout();
        localStorage.setItem('redirectTo', window.location.pathname);

        return router.parseUrl('/');
    }

    return true;
};
